import React, { useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import { getDiseaseHistoryAction } from "../../../../../store/actions/DiseaseHistoryAction.js"; // You must create this action
import { Link } from "react-router-dom";
import { formatDate } from "../../../../../utils/dateUtils.js";
const DiseaseHistory = ({ patientId }) => {
    const dispatch = useDispatch();

    //const patientDetails = useSelector((state) => state.patients?.patientDetails);
    //const patientId = useSelector((state) => state.patients?.patientDetails?.patient_id);
    const diseaseHistory = useSelector((state) => state.diseaseHistory.diseaseHistory);

    useEffect(() => {
        if (patientId) {
            dispatch(getDiseaseHistoryAction(patientId));
        }
    }, [dispatch, patientId]);

    return (
        <div className="card-body">
            <div className="widget-timeline-icon2">
                <ul className="timeline">
                    {diseaseHistory.length === 0 ? (
                        <p className="text-muted">No disease history available.</p>
                    ) : (
                        diseaseHistory.map((entry) => (
                            <li key={entry.patient_disease_history_id}>
                                <div className="icon bg-primary">
                                    <i className="las la-stethoscope" />
                                </div>
                                <Link className="timeline-panel text-muted" to="#">
                                    <h4 className="mb-2 mt-1">{entry.disease_name}</h4>
                                    <p className="fs-15 mb-0">
                                        <strong>Diagnosed:</strong>{" "}
                                        {entry?.created_at ? formatDate(entry.created_at) : "-"}
                                    </p>
                                    <p className="fs-15 mb-0">
                                        <strong>Status:</strong> {entry.disease_status}
                                    </p>
                                    <p className="fs-15 mb-0">
                                        <strong>Current Disease:</strong> {entry.is_current === "Yes" ? "Yes" : "No"}
                                    </p>
                                </Link>
                            </li>
                        ))
                    )}
                </ul>
            </div>
        </div>
    );
};

export default DiseaseHistory;
